export default __webpack_public_path__ + "static/media/bannerLunar1.44926f49.png";